"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conditional = exports.useConditional = void 0;
/* eslint-disable react/require-default-props */
var react_1 = __importStar(require("react"));
var formik_1 = require("formik");
var useConditional = function (_a) {
    var cond = _a.cond, name = _a.name, _b = _a.falseValue, falseValue = _b === void 0 ? null : _b;
    var _c = formik_1.useField(name), setValue = _c[2].setValue;
    react_1.useEffect(function () {
        if (!cond) {
            setValue(falseValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cond, falseValue]);
};
exports.useConditional = useConditional;
/**
  If your form includes fields that render conditionally then wrap them inside
  `Conditional` component exported from storybook.
  import { Conditional } from '@wastehero/storybook/lib/components/formik-kit'
  _Why_:
  Because, normally, when you unmount a field, the value is till in the formik context.
  What Conditional do is to make sure to remove it when the field is not shown.
 */
var Conditional = function (_a) {
    var cond = _a.cond, _b = _a.falseValue, falseValue = _b === void 0 ? null : _b, name = _a.name, children = _a.children;
    exports.useConditional({
        cond: cond,
        falseValue: falseValue,
        name: name,
    });
    if (!cond)
        return react_1.default.createElement(react_1.default.Fragment, null);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.Conditional = Conditional;
